export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/service-page-next.1959623e-33b964.svg";